"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogoUploader = exports.StyledLogoContainer = exports.LogosContainer = exports.LogoCustomise = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.LogoCustomise = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
exports.LogosContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledLogoContainer = styled_components_1.default.div `
  border: ${({ theme, isSelected }) => `1.5px solid ${isSelected ? theme.Color.Brand.Primary : 'transparent'}`};
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
  width: 86px;
  height: 86px;
  background-image: ${({ backgroundUrl }) => backgroundUrl && `url("${backgroundUrl}")`};
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`;
exports.StyledLogoUploader = styled_components_1.default.div `
  display: flex;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
  width: 86px;
  height: 86px;
  background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
//# sourceMappingURL=QRCodeLogo.style.js.map